import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({ children, className = '', onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`${onClick ? 'cursor-pointer' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  /** Overrides the default bottom margin. For dense layouts (the mobile
   *  Add Transaction sheet) that cannot afford 20px under the title. */
  className?: string;
}

export function CardHeader({ title, subtitle, action, className = 'mb-5' }: CardHeaderProps) {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div>
        <p
          className="font-normal uppercase"
          style={{ fontSize: '11px', letterSpacing: '0.1em', color: 'var(--color-label)' }}
        >
          {title}
        </p>
        {subtitle && (
          <p className="text-[11px] mt-0.5" style={{ color: 'var(--color-sub)' }}>{subtitle}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
